import React, { useState, useContext } from 'react';

import { toast } from "react-toastify";

import { useHistory } from 'react-router-dom';

import Card from '../../shared/components/UIElements/Card';
import Input from '../../shared/components/FormElements/Input';
import Button from '../../shared/components/FormElements/Button';

import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';

import {
  VALIDATOR_EMAIL,
  VALIDATOR_MINLENGTH,
  VALIDATOR_REQUIRE
} from '../../shared/util/validators';
import { useForm } from '../../shared/hooks/form-hook';
import { useHttpClient } from '../../shared/hooks/http-hook'; //Added
import { AuthContext } from '../../shared/context/auth-context';
import './Auth.css';
// import footer
import Footer from '../../shared/components/UIElements/Footer';

const Auth = () => {
  const auth = useContext(AuthContext);
  const [isLoginMode, setIsLoginMode] = useState(true);

  const { isLoading, error, sendRequest, clearError } = useHttpClient(); //Added
  /*
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  */

  const [formState, inputHandler, setFormData] = useForm(
    {
      email: {
        value: '',
        isValid: false
      },
      password: {
        value: '',
        isValid: false
      }
    },
    false
  );

  const switchModeHandler = () => {
    if (!isLoginMode) {
      setFormData(
        {
          ...formState.inputs,
          name: undefined,
          mobile: undefined
        },
        formState.inputs.email.isValid && formState.inputs.password.isValid
      );
    } else {
      setFormData(
        {
          ...formState.inputs,
          name: {
            value: '',
            isValid: false
          },
          mobile: {
            value: '',
            isValid: false
          }
        },
        false
      );
    }
    setIsLoginMode(prevMode => !prevMode);
  };

  const history = useHistory();

  const authSubmitHandler = async event => {
    event.preventDefault();

    const LAST_LOGIN_KEY = 'lastLoginAt';
    const SEVEN_DAYS = 1000 * 60 * 60 * 24 * 7;

    if (isLoginMode) {
      try {
        const responseData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL + '/users/login',
          'POST',
          JSON.stringify({
            email: formState.inputs.email.value,
            password: formState.inputs.password.value
          }),
          {
            'Content-Type': 'application/json'
          }
        );
        auth.login(responseData.userId, responseData.token);

        const now = Date.now();
        const lastLoginAt = localStorage.getItem(LAST_LOGIN_KEY);

        if (!lastLoginAt || now - lastLoginAt > SEVEN_DAYS) {
          // Long time no see
          toast.success(`Welcome back${responseData.name ? `, ${responseData.name}` : ''}!`);
        } else {
          // Regular login
          toast.success(`Logged in${responseData.name ? `, ${responseData.name}` : ''}`);
        }

        // Update last login time
        localStorage.setItem(LAST_LOGIN_KEY, now.toString());
        history.push('/' + responseData.userId + '/files');
      } catch (err) {
        toast.error(err.message || "Login failed. Please try again.");
      }

    } else {
      try {
        const responseData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL + '/users/signup',
          'POST',
          JSON.stringify({
            name: formState.inputs.name.value,
            mobile: formState.inputs.mobile.value,
            email: formState.inputs.email.value,
            password: formState.inputs.password.value
          }),
          {
            'Content-Type': 'application/json'
          }
        );
        auth.login(responseData.userId, responseData.token);
        toast.success("Signed up successfully, You’re now logged in!");
        history.push('/' + responseData.userId + '/files');
      } catch (err) {
        toast.error(err.message || "Signup failed. Please try again.");
      }

    }

  };

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      <Card className="authentication">
        {isLoading && <LoadingSpinner asOverlay />}
        <h2>Login Required</h2>
        <hr />
        <form onSubmit={authSubmitHandler}>
          {!isLoginMode && (
            <>
              <Input
                element="input"
                id="name"
                type="text"
                label="Your Name"
                validators={[VALIDATOR_REQUIRE()]}
                errorText="Please enter a name."
                onInput={inputHandler}
              />
              <Input
                element="input"
                id="mobile"
                type="tel"
                label="Mobile Number"
                validators={[
                  VALIDATOR_REQUIRE(),
                  VALIDATOR_MINLENGTH(10),
                ]}
                errorText="Please enter a valid mobile number."
                onInput={inputHandler}
              />
            </>
          )}
          <Input
            element="input"
            id="email"
            type="email"
            label="E-Mail"
            validators={[VALIDATOR_EMAIL()]}
            errorText="Please enter a valid email address."
            onInput={inputHandler}
          />
          <Input
            element="input"
            id="password"
            type="password"
            label="Password"
            validators={[VALIDATOR_MINLENGTH(6)]}
            errorText="Please enter a valid password, at least 6 characters."
            onInput={inputHandler}
          />
          <Button type="submit" disabled={!formState.isValid}>
            {isLoginMode ? 'LOGIN' : 'SIGNUP'}
          </Button>
        </form>
        <Button inverse onClick={switchModeHandler}>
          SWITCH TO {isLoginMode ? 'SIGNUP' : 'LOGIN'}
        </Button>
      </Card>
      {/* Footer */}
      <Footer />
    </React.Fragment>
  );
};

export default Auth;
